module.exports = __webpack_public_path__ + "static/media/registration_image.13cf4b82.png";